//场主版本的工作台
import React, { useState, useMemo, useEffect } from 'react';
import MyTodoList from './components/my-todo-list';
import './index.less';
import ReportProcess from './components/report-process';
import ActivityControl from './components/activity-control';
import { connect } from 'react-redux';
import CmsEntry from './components/cms-entry';
import ActivityBanner from './components/activity-banner';
import MerchantActivityIntro from './components/merchant-activity-intro';
import ActivitySideBanner from './components/activity-side-banner';
import channelActivityApis from '@/apis/channelActivity';
import PlatformMarketingEntry from './components/platform-marketing-entry';
// import GlobalSearch from './components/global-search';
import Notify from './components/notify';
import RecommendActivity from './components/recommend-activity';
import ChangeRole from './components/change-role';
import { logindexpage } from '@/log';
import CollectMicroJoin from './components/collect-micro-join';
import HelpCenterSide from './components/help-center-side';

function OperatePlatform(state) {
  const userMap = state.userMap;
  const [platformMarketingInfo, setPlatformMarketingInfo] = useState({
    count: 0,
    list: [],
  });

  const userType = useMemo(() => {
    if (userMap.userType === 1) {
      if (userMap.hasActivity === 1) {
        return 1; // 管理者有活动
      }
      return 2; // 管理者没活动
    }
    return 3; // 参与者
  }, [userMap]);

  useEffect(() => {
    logindexpage();
  }, []);

  // 请求平台营销阵地接口
  useEffect(() => {
    channelActivityApis.listManageChannel({ otherChannelType: 4 }).then((res) => {
      const { ret, msg, data } = res;
      if (ret !== '0' || !data) {
        throw msg || '平台营销阵地接口请求失败';
      }
      setPlatformMarketingInfo({ ...data });
    });
  }, []);

  const FastEntry = () => {
    if (Number(platformMarketingInfo.count)) {
      return <PlatformMarketingEntry data={platformMarketingInfo} />;
    }
    if (userType !== 2) {
      return <ActivityControl style="simple" />;
    }
    return null;
  };

  return (
    <>
      <div className="operate-platform-wrap" style={{ padding: '0 24px 24px 24px' }}>
        <ActivityBanner />
        {userType === 2 ? <ActivityControl style="whole" /> : null}
        <div className="operate-platform-parent">
          <div className="operate-platform-left">
            <Notify />
            {/* <GlobalSearch /> */}
            <RecommendActivity isField />
            {userType !== 3 ? <MerchantActivityIntro /> : null}
            <MyTodoList showProcess={false} />
            <ReportProcess />
          </div>
          <div className="operate-platform-right">
            <ChangeRole />
            <FastEntry />
            <CmsEntry />
            <CollectMicroJoin />
            {/* 侧边栏引导改为：轮播，可配置 */}
            <ActivitySideBanner />
            <HelpCenterSide />
          </div>
        </div>
      </div>
    </>
  );
}
export default connect((state) => {
  return {
    sideBar: state.sideBar,
    noticeShow: state.noticeShow,
    userMap: state.userInfo.userMap,
  };
})(OperatePlatform);
